import { createApi } from '@reduxjs/toolkit/query/react'
import { store } from 'app/store'
import { IFireQuoteCardDetails } from 'Components/Fire/FireQuotComp'
import { API_ENDPOINTS } from 'Constants'
import { TFireQuotes } from 'Pages/Fire/QuotePage/QuotePage'
import { bgrUrlQuery, bobMasterUrlQuery, getFileHeaders } from 'Services/baseQuery'

export const fireApi = createApi({
  reducerPath: 'fireApi',
  baseQuery: bgrUrlQuery,
  endpoints: (builder) => ({
    getPropertyQuestions: builder.query<any, any>({
      query: (param) => ({
        url: API_ENDPOINTS.BOB.GET_PROPERTY_QUESTIONS,
        method: 'GET',
        params: param,
      }),
    }),
    getOccupancyQuestions: builder.query<any, any>({
      query: (param) => ({
        url: API_ENDPOINTS.BOB.GET_OCCUPANCY_LIST,
        method: 'GET',
        params: param,
      }),
    }),
    firePlanQuote: builder.mutation<any, any>({
      query: (payload) => ({
        url: API_ENDPOINTS.BOB.FIRE_PLAN_QUOTE,
        method: 'POST',
        body: payload,
      }),
    }),

    fireDirectDebitMakePayment: builder.mutation<any, any>({
      query: (payload) => ({
        url: API_ENDPOINTS.BOB.DIRECT_DEBIT_MAKE_PAYMENT_FIRE,
        method: 'POST',
        body: payload,
      }),
    }),

    fireDownloadPolicy: builder.mutation<any, any>({
      query: (payload) => ({
        url: API_ENDPOINTS.BOB.FIRE_DOWNLOAD_POLICY,
        method: 'POST',
        body: payload,
      }),
    }),

    bgrQuoteList: builder.query<any, { trace_id: string }>({
      query: (param) => ({
        url: API_ENDPOINTS.BOB.QUOTE_LISTING,
        method: 'GET',
        params: param,
      }),
    }),

    firePolicyStatus: builder.mutation<
      any,
      { trace_id: string; insurer_code: string; plan_name: string }
    >({
      query: (payload) => ({
        url: API_ENDPOINTS.BOB.FIRE_POLICY_STATUS,
        method: 'POST',
        body: payload,
      }),
    }),
    getQuoteTraceID: builder.query<any, any>({
      query: (body) => ({
        url: API_ENDPOINTS.BOB.GET_FIRE_TRACE_ID,
        method: 'POST',
        body: body,
      }),
    }),
    getQuotes: builder.query<
      {
        data: {
          error_message: []
          status: number
          message: string
          data: IFireQuoteCardDetails
        }[]
        is_completed: boolean
      },
      any
    >({
      query: (param) => ({
        url: API_ENDPOINTS.BOB.GET_FIRE_QUOTES,
        method: 'GET',
        params: param,
      }),
    }),
  }),
})

export const {
  useFirePlanQuoteMutation,
  useFireDirectDebitMakePaymentMutation,
  useFireDownloadPolicyMutation,
  useLazyBgrQuoteListQuery,
  useFirePolicyStatusMutation,
  useLazyGetPropertyQuestionsQuery,
  useGetPropertyQuestionsQuery,
  useGetQuoteTraceIDQuery,
  useLazyGetQuoteTraceIDQuery,
  useGetQuotesQuery,
  useLazyGetQuotesQuery,
  useGetOccupancyQuestionsQuery,
  useLazyGetOccupancyQuestionsQuery,
} = fireApi
